import React, { useState } from 'react';
import { translations as _ } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useSupportSlice } from '../../slice';
import { useParams } from 'react-router-dom';
import AvatarJira from './AvatarJira';
import { selectUserInformationsGet } from 'app/pages/user-informations/slice/selectors';
import cx from 'classnames';
import deleteIcon from 'assets/icons/menu-delete-normal.svg';
import editIcon from 'assets/icons/menu-edit-black.svg';
import CommentEdit from './CommentEdit';
import { selectJiraRequest } from '../../slice/selectors';
import PreviewMedia from './PreviewMedia';
import PreviewAttachment from './PreviewAttachment';

export default function CommentList() {
  const i18nKey = _.support;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { actions: actionsSupport } = useSupportSlice();
  let { requestId } = useParams<{ requestId: string }>();
  const { data: user } = useSelector(selectUserInformationsGet);
  const [editCommentId, setEditCommentId] = useState<string>('');
  const { attachment, allComments, loadingComment } = useSelector(
    selectJiraRequest,
  );

  const [mediaSelected, setMediaSelected] = useState();
  const [isOpenPreview, setIsOpenPreview] = useState(false);

  function handleDeleteComment(comment) {
    let data = { commentId: comment.id, issueKey: requestId };
    dispatch(actionsSupport.deleteComment(data));
  }

  console.log(allComments);
  const publicComments = allComments?.filter(c => c.jsdPublic);

  return (
    <div className="comment-container">
      <div className="activity-text">{t(i18nKey.activity)}</div>

      {publicComments?.map((c, i) => {
        const paragraphs =
          c?.body?.content?.filter(e => e.type === 'paragraph') || [];

        let isMark = c?.body?.content?.find(e => e.type === 'paragraph')
          ?.content?.[1]?.marks?.length;

        let commentAttachment = attachment.length
          ? attachment
              ?.map(att => {
                return c?.body?.content
                  ?.find(e => e.type === 'mediaGroup')
                  ?.content.map(c => {
                    if (att?.content?.includes(c.attrs.id)) {
                      return att;
                    }
                  });
              })
              .flat()
              .filter(e => e)
          : [];

        if ((!commentAttachment?.length && !paragraphs?.length) || isMark) {
          return null;
        }

        return (
          <div
            key={c.created + i}
            className={cx('comment-global', {
              user: c.author.displayName === 'Elistair After Sales Service',
              assignee: c.author.displayName !== 'Elistair After Sales Service',
            })}
          >
            <div className="info-comment-container">
              <div className="row">
                <AvatarJira
                  name={
                    c.author.displayName === 'Elistair After Sales Service'
                      ? `${user?.firstname} ${user?.lastname}`
                      : `${c.author.displayName}`
                  }
                  type={
                    c.author.displayName === 'Elistair After Sales Service'
                      ? 'user'
                      : 'assignee'
                  }
                />
                <span>
                  {c.author.displayName === 'Elistair After Sales Service'
                    ? `${user?.firstname} ${user?.lastname} at ${new Date(
                        c.created,
                      ).toLocaleString()}`
                    : `${c.author.displayName} at ${new Date(
                        c.created,
                      ).toLocaleString()}`}
                </span>
              </div>
              <div className={cx('row actions')}>
                <img
                  onClick={() => {
                    editCommentId !== c.id
                      ? setEditCommentId(c.id)
                      : setEditCommentId('');
                  }}
                  alt="edit-comment"
                  src={editIcon}
                  className="icon edit"
                />
                <img
                  onClick={() => {
                    handleDeleteComment(c);
                  }}
                  alt="delete-comment"
                  src={deleteIcon}
                  className="icon"
                />
              </div>
            </div>
            {editCommentId === c.id ? (
              <>
                <CommentEdit commentData={c} />
              </>
            ) : (
              <div>
                {paragraphs.map((para, index) => (
                  <div className="comment-body" key={index}>
                    {para.content.map((item, i) => {
                      if (item.type === 'text') {
                        return <span key={i}>{item.text}</span>;
                      } else if (item.type === 'hardBreak') {
                        return <br key={i} />;
                      } else {
                        return null;
                      }
                    })}
                  </div>
                ))}
                {commentAttachment ? (
                  <PreviewAttachment
                    attachment={commentAttachment}
                    loadingAttachment={loadingComment}
                    setMediaSelected={setMediaSelected}
                    setIsOpenPreview={setIsOpenPreview}
                    type="comment"
                  />
                ) : null}
              </div>
            )}
          </div>
        );
      })}
      <PreviewMedia
        currentElement={mediaSelected}
        isOpen={isOpenPreview}
        setIsOpen={setIsOpenPreview}
      />
    </div>
  );
}
